import { render, staticRenderFns } from "./WatchVideo.vue?vue&type=template&id=9ebba02c"
import script from "./WatchVideo.vue?vue&type=script&lang=js"
export * from "./WatchVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports